import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: [],
    error: "",
    message: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.GENERIC_LIST_REQUEST:
      return {
        ...state,
        data: [],
        isProgress: true,
        message: "",
      };
    case homeConstants.GENERIC_LIST_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
        message: action.response.message,
      };
    case homeConstants.GENERIC_LIST_FAILURE:
      return {
        data: [],
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: [],
        message: "",
      };
    default:
      return state;
  }
}
